import dayjs from 'dayjs';

const WEEKDAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

export function formatInboxTime(iso: string, now: dayjs.Dayjs = dayjs()): string {
  const day = dayjs(iso);
  if (day.isSame(now, 'day')) {
    return day.format('HH:mm');
  }
  if (day.isSame(now.subtract(1, 'day'), 'day')) {
    return '昨天';
  }
  if (now.diff(day, 'day') < 7) {
    return WEEKDAYS[day.day()];
  }
  if (day.isSame(now, 'year')) {
    return day.format('M/D');
  }
  return day.format('YYYY/M/D');
}

/** 将接口时间（如 2026-10-27T09:49:55.095Z / 2026-10-28T08:51:19.660）格式化为本地可读时间。 */
export function formatFullTime(iso?: string | null): string {
  const text = iso?.trim() ?? '';
  if (!text) return '';
  const day = dayjs(text);
  if (!day.isValid()) return text;
  return day.format('YYYY-MM-DD HH:mm:ss');
}

/** 会员到期时间。支持 ISO 字符串或 { seconds, nanos }；无效或缺失时返回空。 */
export function formatEpochDate(instant?: string | { seconds?: number; nanos?: number } | null) {
  if (instant == null) return '';
  if (typeof instant === 'string') {
    const text = instant.trim();
    if (!text) return '';
    const day = dayjs(text);
    return day.isValid() ? day.format('YYYY-MM-DD') : '';
  }
  const seconds = instant.seconds ?? 0;
  if (seconds <= 0) return '';
  const nanos = instant.nanos ?? 0;
  return dayjs(seconds * 1000 + Math.floor(nanos / 1e6)).format('YYYY-MM-DD');
}

export function remainDaysUntil(instant?: string | { seconds?: number; nanos?: number } | null) {
  const date = formatEpochDate(instant);
  if (!date) return 0;
  return Math.max(0, dayjs(date).startOf('day').diff(dayjs().startOf('day'), 'day'));
}
